module.exports = {
  prefix: function prefix(prop) {
    var match = prop.match(/^(-\w+-)/);

    if (match) {
      return match[0];
    }

    return '';
  },
  unprefixed: function unprefixed(prop) {
    return prop.replace(/^-\w+-/, '');
  }
};